import { Grid, Card, CardContent } from '@mui/material';

import { usersApiKeyStore } from '../../../api/users-api-key-store';
import { FormSelect } from '../../../components/hook-form/form-select.component';
import { divisionApiKeyStore } from '../../../api/masters/division-api-key-store';
import { FormAutoCompleteMultiSelectDynamic } from '../../../components/hook-form/form-autocomplete-multi-select.dynamic.component';
import { rebateCompanyApiKeyStore } from '../../../api/masters/rebate-company-api-key-store';
import { useEffect, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { SelectFieldOption } from '../../../components/hook-form/hook-form-error';
import { FormAutoCompleteSelectDynamic } from '../../../components/hook-form/form-autocomplete-select.dynamic.component';

const styling = {
  root: { paddingRight: '15px', paddingBottom: '10px' },
  paperStyle: { padding: '20px 0px 0' },
  headingStyle: { fontWeight: 'bold' },
  buttonStyle: { width: '130px' },
  linkStyle: {
    color: '#5D6D7E',
    textDecoration: 'none',
  },
};

const rebateOptions: SelectFieldOption[] = [
  { value: 'processing', label: 'Processing', isDefault: false },
  { value: 'notProcessing', label: 'Not Processing', isDefault: false },
  // { value: 'notqualify', label: 'Does Not Qualify', isDefault: false },
  // { value: 'norebate', label: 'No Rebate Program Available', isDefault: false },
];

export interface Option {
  value: any;
  label: string;
  isDefault: boolean;
}

export const OtherFieldForm = () => {
  const { getValues, setValue } = useFormContext();

  useWatch({
    name: ['rebates'] || [],
  });

  const handleRebate = (value: any) => {
    if (value !== 'processing') {
      setValue('rebateCompanies', null);
    }
  };

  const requirementOption = [
    {
      value: 'yes',
      label: 'Yes',
      isDefault: true,
    },
    {
      value: 'no',
      label: 'No',
      isDefault: false,
    },
  ];

  return (
    <Card elevation={0} style={styling.paperStyle}>
      <CardContent className="formContainer">
        <Grid container spacing={2}>
          <Grid item lg={12} sm={12} xl={12} xs={12}>
            <Grid container spacing={2}>
              <Grid item lg={3} sm={3} xl={3} xs={3}>
                <FormSelect name="customerPoRequirement" label="PO Requirements" options={requirementOption} />
              </Grid>
              <Grid item lg={3} sm={3} xl={3} xs={3}>
                <FormSelect name="rebates" label="Rebates" onChange={handleRebate} options={rebateOptions} />
              </Grid>
              {/* <Grid item lg={6} sm={6} xl={6} xs={6}>
                <FormAutoCompleteSelectDynamic
                  name="rebateCompanies"
                  label="Rebate/Utility Company"
                  disabled={getValues('rebates') == 'processing' ? false : true}
                  getQueryKeyConfig={() => rebateCompanyApiKeyStore.getRebateCompanies()}
                  optionsValueKey="utilRebateCompanyID"
                  optionsLabelKey="utilRebateCompanyName"
                />
              </Grid> */}
              <Grid item lg={3} sm={3} xl={3} xs={3}>
                <FormAutoCompleteMultiSelectDynamic
                  name="customerAccountManagers"
                  label="Account Managers"
                  getQueryKeyConfig={() => usersApiKeyStore.getUsersByRole('AMG')} // TODO - revisit the hardcoded data
                  optionsLabelKey="fullName"
                  optionsValueKey="userID"
                />
              </Grid>
              <Grid item lg={3} sm={3} xl={3} xs={3}>
                <FormAutoCompleteMultiSelectDynamic
                  name="customerDivisions"
                  label="Divisions"
                  getQueryKeyConfig={() => divisionApiKeyStore.getDivisions()}
                  optionsLabelKey="divisionName"
                  optionsValueKey="divisionID"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
